import React, { Component } from 'react'

// components
// import ContactForm from './ContactForm/ContactForm'
import SocialList from './SocialList/SocialList'

class Contact extends Component {
  constructor() {
    super()

    this.state = {
      contactForm: {
        name: '',
        email: '',
        phoneNo: '',
        message: ''
      }
    }

    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  handleFormSubmit(event) {
    event.preventDefault()
    console.log(this.state)
    /**
     * Need to add the rest of the functionality here
     */
  }

  render() {
    return (
      <div className="section" id="contact">
        <div className="container">
          <div className="col-md-12">
            <h4>04</h4>
            <h1 className="size-50">Contact Me</h1>
            <div className="h-50"></div>
          </div>

          <div className="col-md-4">
            <h3>Mobile Number</h3>
            <p>
              <i className="ion-social-whatsapp"></i> +27 69 496 1184
            </p>
            <h3>Email</h3>
            <p>
              <i className="ion-email"></i> shaeensingh98@gmail.com
            </p>

            <h3>Social Network</h3>

            <SocialList />
            <div className="clearfix"></div>
            <div className="h-50"></div>
          </div>

          <div className="col-md-8">
            {/* <ContactForm
              formDetails={this.state.contactForm}
              handleFormSubmit={this.handleFormSubmit}
            /> */}
          </div>
        </div>
      </div>
    )
  }
}

export default Contact
